import { formInput, formInputAddress, formRow } from '@rocketfinancialcorp/rocket-ui/form';

import { POSTAL_CODE_LABEL, STATE_PROVINCE_LABEL } from '@shared/constants/identity-formats';

const expressions = {
  'props.required':
    '!!model.addressLine1 || !!model.addressLine2 || !!model.city || !!model.state || !!model.postalCode || !!model.country',
  'props.disabled': 'model.category !== "EXTERNAL"',
};

export const addressFields = [
  formRow([
    formInputAddress({
      key: 'addressLine1',
      label: 'Billing address 1',
      props: {
        minLength: 1,
        maxLength: 50,
        // This is the financial-account BILLING address, not a customer identity address. Deliberately left
        // US-only - widening it is a financial-account question, outside this ticket. Only the labels below are
        // shared with the customer address forms, for consistency.
        countryRestrictions: ['US'],
      },
      expressions,
    }),
  ]),
  formRow([
    formInput({
      key: 'addressLine2',
      label: 'Billing address 2',
      props: { minLength: 1, maxLength: 50 },
      expressions: { 'props.disabled': 'model.category !== "EXTERNAL"' },
    }),
  ]),
  formRow([
    formInput({ key: 'city', label: 'City', className: 'city-field', props: { minLength: 1, maxLength: 25 }, expressions }),
    formInput({
      key: 'state',
      label: STATE_PROVINCE_LABEL,
      className: 'state-field',
      props: { minLength: 2, maxLength: 3 },
      validators: { validation: [{ name: 'isValidStateCode' }] },
      expressions,
    }),
    formInput({
      key: 'postalCode',
      label: POSTAL_CODE_LABEL,
      className: 'postal-code-field',
      props: { minLength: 1, maxLength: 10 },
      expressions,
    }),
  ]),
  formRow([
    formInput({
      key: 'country',
      label: 'Country',
      parsers: [(value?: string) => value?.toUpperCase()],
      props: { minLength: 3, maxLength: 3 },
      validators: { validation: [{ name: 'isValidCountryCode' }] },
      validation: {
        messages: {
          minLength: 'Must be 3 characters',
        },
      },
      expressions,
    }),
  ]),
];
